/**
 * useWeeklyTheme, hook simples para consumir /api/weekly-theme/current.
 * Retorna { theme, loading, error }. Cache de módulo + revalida ao virar o dia.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = undefined;
let _cacheDate = null;
let _inflight = null;
const _subs = new Set();

function _todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function _broadcast() {
  _subs.forEach((fn) => fn(_cache));
}

async function _fetch() {
  if (_inflight) return _inflight;
  _inflight = api
    .get("/weekly-theme/current")
    .then(({ data }) => {
      _cache = data?.theme || null;
      _cacheDate = _todayKey();
      _broadcast();
      return _cache;
    })
    .catch(() => {
      _cache = null;
      _broadcast();
      return _cache;
    })
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export default function useWeeklyTheme() {
  const [theme, setTheme] = useState(_cache);
  useEffect(() => {
    const sub = (val) => setTheme(val);
    _subs.add(sub);
    if (_cache === undefined || _cacheDate !== _todayKey()) {
      _fetch();
    }
    return () => {
      _subs.delete(sub);
    };
  }, []);
  return { theme, loading: theme === undefined };
}
